import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SimpleHgType } from 'lion-api';

@Component({
  selector: 'app-form-comment',
  templateUrl: './form-comment.component.html',
  styleUrl: './form-comment.component.scss',
  standalone: false
})
export class FormCommentComponent {
  @Input() attachForm?: FormGroup;
  @Input() tradeTransactionType?: SimpleHgType;
  @Input() isDzbankUser?: boolean;

  protected readonly SimpleHgType = SimpleHgType;
}
